import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Route guard to protect authenticated routes
 * Redirects to login if user is not authenticated
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Return Observable<boolean> - guard will wait for it to complete
  return authService.checkAuth().pipe(
    map(isAuthenticated => {
      if (isAuthenticated) {
        return true;
      }

      // Store the attempted URL for redirecting after login
      const returnUrl = state.url;
      router.navigate(['/login'], { queryParams: { returnUrl } });
      return false;
    })
  );
};

/**
 * Route guard to prevent authenticated users from accessing login page
 * Redirects to dashboard if user is already authenticated
 */
export const loginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Return Observable<boolean> - guard will wait for it to complete
  return authService.checkAuth().pipe(
    map(isAuthenticated => {
      if (!isAuthenticated) {
        return true; // Allow access to login page
      }

      // User is already authenticated, redirect to dashboard
      router.navigate(['/dashboard']);
      return false;
    })
  );
};
